export const lightTheme = {
  primary: "#F9C85F",
  secondary: "rgba(45, 47, 50, 1)",
  green: "#00CDA6",

  bgColor: "#F1F4F8",
  bgDark: "#2D2F32",
  bgWhite: "#fff",

  gray100: "#2D2F32",
  gray90: "#E0E3E7",
  gray80: "#525558",

  textWhite: "#fff",
  primaryText: "#2D2F32",
  secondaryText: "#525558",

  highlightOrange: "#F59432",
  highlightPink: "#FE7A95",
};

export const darkTheme = {
  primary: "#F9C85F",
  secondary: "rgba(45, 47, 50, 1)",
  green: "#00CDA6",

  bgColor: "#F1F4F8",
  bgDark: "#2D2F32",
  bgWhite: "#fff",

  gray100: "#2D2F32",
  gray90: "#E0E3E7",
  gray80: "#525558",

  textWhite: "#fff",
  primaryText: "#2D2F32",
  secondaryText: "#525558",

  highlightOrange: "#F59432",
  highlightPink: "#FE7A95",
};
